var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56,
    viewBox: "0 0 80 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5737 39.217C37.8501 41.5673 34.3171 42.9862 30.4566 42.9862C21.8425 42.9862 14.8594 35.922 14.8594 27.2079C14.8594 18.4939 21.8425 11.4297 30.4566 11.4297C34.3171 11.4297 37.8501 12.8485 40.5737 15.1989C43.2972 12.8485 46.8302 11.4297 50.6908 11.4297C59.3048 11.4297 66.2879 18.4939 66.2879 27.2079C66.2879 35.922 59.3048 42.9862 50.6908 42.9862C46.8302 42.9862 43.2972 41.5673 40.5737 39.217Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5742 39.2173C43.928 36.3233 46.0547 32.0169 46.0547 27.2079C46.0547 22.399 43.928 18.0926 40.5742 15.1986C43.2978 12.8484 46.8306 11.4297 50.6909 11.4297C59.305 11.4297 66.2881 18.4939 66.2881 27.2079C66.2881 35.922 59.305 42.9862 50.6909 42.9862C46.8306 42.9862 43.2978 41.5675 40.5742 39.2173Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5738 39.2171C43.9273 36.3231 46.0538 32.0169 46.0538 27.2082C46.0538 22.3995 43.9273 18.0932 40.5738 15.1992C37.2202 18.0932 35.0938 22.3995 35.0938 27.2082C35.0938 32.0169 37.2202 36.3231 40.5738 39.2171Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.f27429edb63297a08edba0b39aee3258.svg";
export { ForwardRef as ReactComponent };